import { TESTIMONIALS, IMAGES } from "../../data/site";

export default function Clients() {
  const logos = [...IMAGES.logos, ...IMAGES.logos, ...IMAGES.logos];
  return (
    <section
      data-testid="clients-section"
      className="py-20 md:py-28 border-t border-black/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-6 h-px bg-[#FF331F]" />
          <span className="font-mono-ibm text-[11px] tracking-[0.2em] uppercase text-[#FF331F]">
            Trusted by teams at
          </span>
        </div>

        <div className="overflow-hidden relative border-y border-black/10 py-10">
          <div className="marquee-track">
            {logos.map((src, i) => (
              <div
                key={i}
                className="w-44 md:w-56 flex-shrink-0 mx-10 flex items-center justify-center"
              >
                <img
                  src={src}
                  alt="Client logo"
                  className="max-h-12 object-contain opacity-80 hover:opacity-100 transition-opacity"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-px bg-black/10 border border-black/10">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white p-8 md:p-12"
            >
              <div className="font-display text-3xl md:text-4xl leading-[1.15] tracking-tight text-[#0A0A0A]">
                <span className="text-[#2F6B1F]">“</span>
                {t.quote}
                <span className="text-[#2F6B1F]">”</span>
              </div>
              <div className="mt-8 flex items-center justify-between border-t border-black/10 pt-5">
                <div className="font-mono-ibm text-xs uppercase tracking-widest text-[#404040]">
                  {t.author}
                </div>
                <div className="font-mono-ibm text-xs uppercase tracking-widest text-[#0A0A0A]">
                  {t.org}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
